import { apiWrapper } from "@/services/api";

export const validBook = async (id) => {
  try {
    const apiParams = JSON.stringify(true);
    console.log("validBook :>> ", apiParams);
    await apiWrapper("PUT", `books/${id}/is_valid`, apiParams);
  } catch (err) {
    console.log("ERROR!! validBook()");
    throw err;
  }
};
